import moment from 'moment';

// DATES
export const DISPLAY_DATE_FORMAT = 'D MMMM Y';
export const TRANSPORT_DATE_FORMAT = 'DD-MM-YYYY';
export const MIN_DATE = moment({ year: 2016 });
export const MAX_DATE = moment().add(10, 'year').endOf('year');





// WEBPACK FOOTER //
// ./src/shared/config/widget.js